module.exports = {
    getReadWidget:   () => '<span>{{(value ? value*1000: value)|date:"M/d/yy H:mm"}}</span>',
    getLinkWidget:   () => '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>',
    getFilterWidget: () => '<ma-date-field field="::field" value="value"></ma-date-field>',
    getWriteWidget:  () => '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>'
};



// WEBPACK FOOTER //
// ./client/app/fieldView/UnixTimeFieldView.js